import { NotificationsState } from './notifications.state';

export const selectNotifications = (state: {
  notifications: NotificationsState;
}) => state.notifications.notifications;
